function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9121 6.16646C17.4255 5.67994 16.6367 5.67994 16.1502 6.16646L7.04735 15.2693L2.64274 10.8647C2.15622 10.3782 1.36742 10.3782 0.880897 10.8647C0.394378 11.3512 0.394377 12.14 0.880897 12.6266L5.87279 17.6184C5.92618 17.6718 5.98231 17.7208 6.04071 17.7654C6.07821 17.8167 6.12011 17.8658 6.16643 17.9121C6.65295 18.3986 7.44175 18.3986 7.92828 17.9121L8.22192 17.6184L17.9121 7.9283C18.3986 7.44178 18.3986 6.65298 17.9121 6.16646Z",
  fill: "#0DBCAE"
});

var SvgSelected = function SvgSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selected.515b677b.svg";
export { ForwardRef as ReactComponent };